import {
  Container,
  Title,
  StyledLink,
  Button,
  Inner,
  DividerWrapper,
} from '../../styles';
import { ABOUT_US_INFO } from '../../../../constants';
import React, { useState } from 'react';
import { Divider } from '../../../Divider/Divider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronDown,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons';

export const AboutUs = () => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <Container>
      <Title>{ABOUT_US_INFO.TITLE}</Title>
      <Button onClick={() => setIsOpen(prev => !prev)}>
        {ABOUT_US_INFO.TITLE}
        {<FontAwesomeIcon icon={isOpen ? faChevronDown : faChevronRight} />}
      </Button>
      <Inner $active={isOpen}>
        <StyledLink href={process.env.REACT_APP_LINK_GITHUB_URL}>
          {ABOUT_US_INFO.GITHYUB}
        </StyledLink>
        <StyledLink href={process.env.REACT_APP_LINK_GOOGLEPLAY_URL}>
          {ABOUT_US_INFO.GOOGLE_PLAY}
        </StyledLink>
        <StyledLink href={process.env.REACT_APP_LINK_APPSTORE_URL}>
          {ABOUT_US_INFO.APP_STORE}
        </StyledLink>
      </Inner>
      <DividerWrapper>
        <Divider />
      </DividerWrapper>
    </Container>
  );
};

AboutUs.displayName = 'AboutUs';
